module.exports = __webpack_public_path__ + "static/img/product_img_6.3a8bafb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/product_img_6.png
// module id = BIvi
// module chunks = 22